import { Tab, Tabs, Typography } from "@material-ui/core";
import React from "react";
import {
  ExcelBtn,
  GenerateBtn, GroupBtn,
  PrintBtn
} from "../components/CRUD/btn";
import CRUD from "../components/CRUD/crud";
import { EditDateTime } from "../components/CRUD/fields";
import { FormInline } from "../components/CRUD/form";
import Info from "../components/CRUD/info";
import CrudToolbar from "../components/CRUD/toolbar";
import Lang from "../components/Lang/lang";
import { formatDateTime, formatPrice } from "../helpers";

export default class Analytics extends CRUD {
  constructor(props) {
    super(props);
    this.object = "report";
    this.state = this.changeTab(0);
  }

  changeTab = (idx) => {
    if (idx === 0) {
      return {
        title: "SaleAnalytics",
        tabIdx: idx,
        data: [],
        columns: [
          { key: "user", label: "User" },
          { key: "issued_on", label: "Issued On", render: formatDateTime },
          { key: "invoice_nr", label: "Invoice Nr." },
          { key: "client", label: "Client" },
          { key: "article", label: "Article" },
          {
            key: "amount",
            label: "Quantity",
            render: (v) => v.toFixed(2),
            numeric: true,
            sum: true,
          },
          {
            key: "price_no_vat",
            label: "Price No Vat",
            numeric: true,
            render: formatPrice,
          },
          {
            key: "total_no_vat",
            label: "Total No Vat",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
          {
            key: "total_vat",
            label: "Vat",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
          {
            key: "total",
            label: "Total",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
        ],
        params: { from: new Date(), to: new Date() },
      };
    } else {
      return {
        title: "PurchaseAnalytics",
        tabIdx: idx,
        data: [],
        columns: [
          { key: "user", label: "User" },
          { key: "konto", label: "Konto" },
          { key: "issued_on", label: "Issued On", render: formatDateTime },
          { key: "invoice_nr", label: "Invoice Nr." },
          { key: "supplier", label: "Supplier" },
          { key: "article", label: "Article" },
          {
            key: "amount",
            label: "Qty",
            render: (v) => v.toFixed(2),
            numeric: true,
            sum: true,
          },
          {
            key: "price_no_vat",
            label: "Price No Vat",
            numeric: true,
            render: formatPrice,
          },
          {
            key: "rabat",
            label: "Rabat",
            numeric: true,
            render: (v) => v.toFixed(0) + "%",
          },
          {
            key: "total_no_vat",
            label: "Total No Vat",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
          {
            key: "total_vat",
            label: "Vat",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
          {
            key: "total",
            label: "Total",
            numeric: true,
            sum: true,
            render: formatPrice,
          },
        ],
        params: { from: new Date(), to: new Date() },
      };
    }
  };

  generate = () => {
    this.setState({ data: null });

    if (this.state.tabIdx === 0) {
      let where = [
        "issued_on > " + this.state.params.from.toISOString(),
        "issued_on < " + this.state.params.to.toISOString(),
      ];

      this.query({
        [this.object]: {
          SaleAnalytics: {
            fields: this.state.columns.map((c) => c.key),
            where: where,
          },
        },
      }).then((data) => {
        this.setState({ data: data[this.object].SaleAnalytics });
      });
    } else {
      let where = [
        "issued_on > " + this.state.params.from.toISOString(),
        "issued_on < " + this.state.params.to.toISOString(),
      ];

      this.query({
        [this.object]: {
          PurchaseAnalytics: {
            fields: this.state.columns.map((c) => c.key),
            where: where,
          },
        },
      }).then((data) => {
        this.setState({ data: data[this.object].PurchaseAnalytics });
      });
    }
  };

  toolbar = () => (
    <CrudToolbar
      leftForm={
        <FormInline>
          <EditDateTime name="from" data={this.state.params} />
          <EditDateTime name="to" data={this.state.params} />
          <GenerateBtn onClick={this.generate} />
        </FormInline>
      }
      tabs={
        <Tabs
          value={this.state.tabIdx}
          indicatorColor="primary"
          textColor="primary"
          onChange={(_, idx) => {
            this.setState({ data: [] }, () => {
              this.setState(this.changeTab(idx));
            });
          }}
        >
          <Tab
            label={
              <Typography>
                <Lang>SALE</Lang>
              </Typography>
            }
          />
          <Tab
            label={
              <Typography>
                <Lang>PURCHASE</Lang>
              </Typography>
            }
          />
        </Tabs>
      }
      left={<Info title={this.state.title} />}
      right={
        <GroupBtn>
          <PrintBtn refPrint={this.printRef} />
          <ExcelBtn crud={this} />
        </GroupBtn>
      }
    />
  );
}
